export default {
  UPLOAD_FILE_REQUIRED: 'file_required',
  UPLOAD_FILE_ALLOWED: 'file_upload_allowed',
  UPLOAD_FILE_NONE: 'no_file'
} as Dictionary<homeworkUploadFileType>
